export default "__VITE_ASSET__a71f56b4__"